import React from 'react';
import './AriaAvatar.css';

export default function AriaAvatar({ state }) {
  // state: 'idle' | 'speaking' | 'listening' | 'thinking'
  return (
    <div className={`aria-avatar aria-${state}`}>
      {/* Outer rings */}
      <div className="av-ring av-ring-3" />
      <div className="av-ring av-ring-2" />
      <div className="av-ring av-ring-1" />

      {/* Main face circle */}
      <div className="av-face">
        {/* Hair */}
        <div className="av-hair" />

        {/* Face features */}
        <div className="av-inner-face">
          {/* Eyes */}
          <div className="av-eyes">
            <div className="av-eye">
              <div className="av-pupil" />
              <div className="av-shine" />
            </div>
            <div className="av-eye">
              <div className="av-pupil" />
              <div className="av-shine" />
            </div>
          </div>

          {/* Nose */}
          <div className="av-nose" />

          {/* Mouth */}
          <div className={`av-mouth ${state === 'speaking' ? 'talking' : ''}`}>
            <div className="av-lip-top" />
            <div className="av-lip-bottom" />
          </div>
        </div>
      </div>

      {/* State indicator */}
      <div className="av-state-badge">
        {state === 'speaking' && <span>🔊 Speaking...</span>}
        {state === 'listening' && <span>🎤 Listening...</span>}
        {state === 'thinking' && <span>💭 Thinking...</span>}
        {state === 'idle' && <span>⏳ Ready</span>}
      </div>

      {/* Sound waves when speaking */}
      {state === 'speaking' && (
        <div className="av-sound-waves">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="wave-bar" style={{ animationDelay: `${i * 0.1}s` }} />
          ))}
        </div>
      )}

      {/* Mic waves when listening */}
      {state === 'listening' && (
        <div className="av-listen-ring">
          <div className="lr-1" />
          <div className="lr-2" />
          <div className="lr-3" />
        </div>
      )}
    </div>
  );
}
